import { render, staticRenderFns } from "./VoiceChat.vue?vue&type=template&id=2a8b63c7&scoped=true"
import script from "./VoiceChat.vue?vue&type=script&lang=js"
export * from "./VoiceChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b63c7",
  null
  
)

export default component.exports